if (!customElements.get('overview-scroll-cards')) {
  class OverviewScrollCards extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(evt) {
      const trigger = evt.target.closest('[data-overview-scroll-card]');
      if (!trigger) return;

      const hash = trigger.hash;
      if (!hash || hash === '#') return;

      const target = this.getScrollTarget(hash);
      if (!target) return;

      evt.preventDefault();
      this.scrollToTarget(target);

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', hash);
      }
    }

    getScrollTarget(hash) {
      const id = hash.slice(1);
      if (!id) return null;

      return document.getElementById(id);
    }

    scrollToTarget(target) {
      const headerOffset = this.getHeaderOffset();
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }

    getHeaderOffset() {
      const headerEnd = getComputedStyle(document.documentElement).getPropertyValue('--header-end');
      const parsedHeaderEnd = Number.parseFloat(headerEnd);
      return Number.isFinite(parsedHeaderEnd) ? parsedHeaderEnd + 24 : 24;
    }
  }

  customElements.define('overview-scroll-cards', OverviewScrollCards);
}
